(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.result-card.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.result-card.js');
"use strict";

const Paper = svs.ui.ReactPaper;
const SkeletonLine = svs.components.lbUi.SkeletonLine;
const WagerSkeletonResultCard = () => React.createElement(Paper, {
  branding: "sport",
  className: "pg_my_bets_wager_fallback__grid__result_card"
}, React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__result_card__header"
}), React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__result_card__footer"
}));
setGlobal('svs.components.tipsen.modularBase.WagerSkeletonResultCard', WagerSkeletonResultCard);

 })(window);